import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "f273085b-9be6-4e7e-bda4-e4bc086ba2fd",
    label: "DG(BLDG)'s Office Order No. 11 of 2017-2018",
    date: "24/02/2018",
    subject:
      "Guideline for Prevention of Mosquito breeding at construction site",
  },
  {
    fileStoreId: "fc9b6d28-aaf9-4bdf-a22e-db22d09dc651",
    label: "DG(BLDG)'s Office Order No. 09 of 2017-2018",
    date: "12/12/2017",
    subject: "Municipal infrastructure to allow FAR ur 69A",
  },
  {
    fileStoreId: "bf9a2c73-7c37-4a78-9725-6113c060578a",
    label: "DG(BLDG)'s Office Order No. 07 of 2017-2018",
    date: "23/11/2017",
    subject:
      "To affix guideline for prevention of Envt pollution at the back of sanction plan",
  },
  {
    fileStoreId: "af28329d-4560-4216-84d4-5c73924a90fe",
    label: "DG(BLDG)'s Office Order No. 04 of 2017-2018",
    date: "06/09/2017",
    subject:
      "mcasures to be taken for cnsuring desired air quality during under 17 FIFA world cup football t. kolkata",
  },
  {
    fileStoreId: "1092c687-7590-4571-bd53-1bcbae977798",
    label: "DG(BLDG)'s Office Order No. 03 of 2017-2018",
    date: "11/08/2017",
    subject:
      "Guidelines for prevention of mosquito breeding at construction site",
  },
];

const Building_OfficeOreder_2017 = () => (
  <TableStructure
    title="Office Order/ 2017"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2017;
